import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchGISDealerList = createAsyncThunk("fetchGISDealerList", async () => {
	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`/gis/dealer/location/list`, config);

	return response.data.data;
});

const gisDealerLocationListSlice = createSlice({
	name: "gisDealerLocationListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchGISDealerList.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchGISDealerList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchGISDealerList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default gisDealerLocationListSlice.reducer;
